<template>
    <v-container v-if="this.zamawiajacy" class="page">
  <table>
    <thead>
    <tr><td>
  
  <div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
    <div class="left-cointainer">
      <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
    </div>
    <div class="right-cointainer">
      Tutore Poland Sp. z o.o.<br>
      ul. Piotrkowska 157A, 90-440 Łódź<br>
      NIP: 7272846163
    </div>
  </div>
  
    </td></tr>
    </thead>
  <tbody>
  <tr><td>
  
    <p align="center" style="margin-top:20px;">
      <strong>COOPERATION AGREEMENT</strong>
  </p>
  <p>
      Concluded in Łódź between:
  </p>
  <p><strong>Principal:</strong></p>
  <p>
    <strong>Tutore Poland Sp. z o.o.</strong>, with its registered office in Łódź at Piotrkowska Street 157A, 90-440 Łódź, entered into the Register of Entrepreneurs of the National Court Register kept by the District Court for Łódź Śródmieście in Łódź, XX Commercial Division of the National Court Register under KRS number: 0000867745, NIP: 7272846163, REGON: 387448002, with a share capital of 5,000.00 PLN, represented by: 
  </p>
  <p>
    <strong>{{zamawiajacy}}</strong>,
  </p>
  <p>and</p>
  
    <strong>Contractor:</strong>
    <br/>
    Full Name: {{imieNazwisko}}
    <br/>
    PESEL: {{pesel}}
    <br/>
    Residential Address: {{zamieszkany}}
    <br/>
    Phone Number: {{nrTelefonu}}
    <br/>
    E-mail: {{email}}
    <br/>
    Bank Account Number: {{nrRachunku}}
    <br/>
    <br/>
    conducting business activity under the company name:
    <br/>
    Company Name: <strong>{{ nazwaFirmy }}</strong>
    <br/>
    Company Address: <strong>{{ siedzibaFirmy }}</strong>
    <br/>
    NIP: <strong>{{ nip }}</strong>
    <br/>
    REGON: <strong>{{ regon }}</strong>
    <br/>
    <br/>  

    <p align="center"><strong>Contract Conditions</strong></p>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 1 Subject of the Contract</strong>
  </p>
  <p style="margin-bottom: 0px;">The Principal commissions, and the Contractor undertakes to perform the following activities for remuneration for the Principal:
  </p>
  <ol>
    <li>Preparing and conducting online or stationary classes for all course participants organized by the Principal in accordance with the educational program indicated by the Principal and the class schedule (which may be in electronic form); conducting/animating interactive classes;</li>
    <li>Diligently and systematically keeping documentation confirming the completion of classes, including, in particular: maintaining a class register by updating it at the beginning or end of each class, no later than the end of the day on which the classes were held or planned, attendance lists and/or marking appropriate class statuses in the system, documentation regarding the evaluation of students, reports on the implementation of classes, and reports required by B2B clients - in the form and within the deadlines set by the Principal;</li>
    <li>Timely execution of all organizational guidelines from the Principal within the deadlines specified by them;</li>
    <li>Conducting make-up classes;</li>
    <li>Caring for the proper condition of the Principal's property and maintaining order and cleanliness in the place of contract performance;</li>
    <li>Cooperating with persons designated by the Principal;</li>
    <li>Regularly and promptly (no later than the end of each working day) reading messages sent by persons designated by the Principal to the Contractor via email, SMS, or through internet communicators and, if necessary, responding as quickly as possible to the information, particularly:
      <ol type="a">
        <li>Providing necessary information within the scope specified in the given situation;</li>
        <li>Participating in meetings, visits, and evaluations at the times set by the Principal;</li>
      </ol>
    </li>
    <li>Cooperating with course participants or, in the case of minors, with their parents or legal guardians, particularly by providing necessary information regarding the service (e.g., assigning homework, checking and delivering student progress reports);</li>
    <li>From the day of receiving access to their teacher account, the Contractor is obliged to record their availability or unavailability during the contract period and update it regularly on their teacher account;</li>
    <li>Other tasks and projects commissioned by the Principal.</li>
  </ol>
  <p>To ensure the conditions for the performance of this contract, the Principal agrees to provide all necessary teaching materials, such as educational panels, graphics for presentations, and an individual account in the online learning system. The above does not include electronic equipment (computer, sound system, etc.), which the Contractor is obliged to organize at their own expense.</p>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 2 Contract Performance</strong>
  </p>
  <ol>
    <li>The Contractor undertakes to perform the subject of this contract with due diligence.</li>
    <li>The Contractor agrees to conduct online classes using functional electronic equipment (computer, webcam, sound system, microphone) each time.</li>
    <li>The performance of the subject of the contract specified in § 1 may take place online via platforms provided by the Principal, in a stationary format at the Principal's selected facility, at the Client's location, or at a facility designated by the Principal. The format of the classes will be determined in the class schedule. The Principal will allow the Contractor to use the platforms necessary for conducting classes.</li>
    <li>The parties agree that the calculation unit is 60 minutes of classes according to the established schedule.</li>
    <li>The total number of teaching hours to be completed will be specified in the schedule each time by the Principal in advance and summarized at the end of each calendar month.</li>
    <li>The parties allow for the possibility of changing the dates and times of the classes specified in the schedule only by mutual agreement.</li>
    <li>The Contractor will perform the services covered by this contract independently from the Principal. In particular, the Principal will not have the right to exercise any managerial rights over the Contractor, not interfering with the organization and/or discipline of the Contractor's work. Any technical or methodological problems concerning the entirety of the tasks entrusted to the Contractor will be resolved by mutual agreement of the parties, respecting the independence of the professional activity conducted by the Contractor.</li>
    <li>The Contractor may not delegate the performance of the subject of this contract to a third party.</li>
    <li>With the Contractor's consent, the Principal may assign classes in a stationary unit agreed upon by both parties.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 3 Information Obligation</strong>
  </p>
    <ol>
      <li>The Principal is obliged to provide the Contractor with all necessary information to perform the subject of the contract and individual assignments.</li>
      <li>The Contractor is obliged to provide the Principal with the necessary information about the progress of the performance of the subject of the contract and individual assignments.</li>
    </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 4 Absences and Notification</strong>
  </p>
  <ol>
    <li>If the Contractor is unable to conduct the classes specified in § 1 on the dates specified in the schedule due to reasons on the Contractor's part, the Contractor is obliged to notify the Principal immediately of the situation, no later than 7 days before the scheduled classes. In such a case, the Principal may appoint a person to replace the Contractor in performing the task described in this contract.</li>
    <li>In the case of sudden illness or poor health, the Contractor may not comply with the 7-day notification period of inability to perform the assignment but is obliged to notify the Principal immediately, no later than 4 hours after the event. The cancellation should occur no later than 24 hours before the scheduled class, which the Contractor plans to cancel, to allow the Principal to arrange for a replacement or to notify the rescheduling of classes.</li>
    <li>In the case of sudden illness or poor health, which occurs suddenly, the Contractor may not comply with the 7-day notification period of inability to perform the assignment but is obliged to notify the Principal immediately after the event. The Contractor confirms this based on an e-sick leave, which will be submitted to the Principal's profile in the PUE ZUS portal.</li>
    <li>The Contractor has the right to cancel up to 10% of the classes organized as part of the course.</li>
    <li>If the classes are not conducted on the date resulting from the schedule and the Principal is not informed of this fact with at least 7 days' notice before the scheduled classes, the Principal may terminate the contract with immediate effect without notice. In such a case, regardless of the possibility of terminating the contract, the Principal may also claim a contractual penalty of PLN 5,000 (in words: five thousand zlotys) from the Contractor for the losses incurred. The Principal may also seek damages exceeding the value of the stipulated contractual penalty. The above provision does not apply to random events that prevent the Contractor from notifying the Principal of the inability to conduct classes.</li>
    <li>If the Contractor cannot conduct the classes scheduled according to the schedule and the Principal cannot find a replacement, the Contractor is obliged to conduct the classes in the amount equal to the missed classes, so-called make-up classes § 1 para. 4, on another date agreed in writing with the Principal.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 5 Contract Duration and Termination</strong>
  </p>
  <ol>
    <li>The parties enter into a contract from {{ dataObowiazywaniaUmowy() }} to {{ datakon }}.</li>
    <li>The parties may terminate the contract with one month's notice, effective at the end of the next calendar month, by submitting written notice of termination (subject to para. 3 of this section).</li>
    <li>The Principal has the right to terminate this contract without notice in cases specified in the contract, as well as in the event of the inability to entrust the subject of this contract or if the Contractor violates the provisions of this contract, by which the parties particularly understand:
      <ol type="a">
        <li>The Contractor's behavior involving the non-performance of obligations specified in § 1 despite prior notice from the Principal to stop the violations,</li>
        <li>Violation by the Contractor of the non-compete clause,</li>
        <li>Disclosure by the Contractor of Confidential Information,</li>
        <li>Any other violations of this contract.</li>
      </ol>
    </li>
    <li>The Principal's statement on the termination of the contract with immediate effect may be made either in written or documentary form.</li>
    <li>If the contract is terminated, the Contractor is obliged to return the materials provided for the duration of the contract by the Principal within 14 days of the termination or expiration of the contract. If the materials are not returned within the specified time, the Principal may impose a financial penalty on the Contractor equal to the value of the received materials. Additionally, the Contractor may be charged for shipping costs.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 6 Remuneration</strong>
    </p>
  <ol>
  <!-- changed to service rates types -->
   <p> 
    <li>For the correct performance of the activities listed in § 1 of the Contract and the tasks assigned to the Contractor, the Contractor will receive remuneration in the amount of: </li>
   </p>
   <div v-html="usluga"></div>
  </br>
  <li>In the case of conducting in-person classes as an instructor in educational institutions (nurseries, kindergartens, primary schools, secondary schools, universities), the rate is 31PLN gross per lesson as defined in § 2 section 3.</li>

  <table class="wage-table" style="page-break-inside: avoid;">
      <caption>Table No. 1 Tariff of rates for stationary classes in primary schools in the Back to School project</caption>
      <tr>
        <th>Number of active course participants</th>
        <th>Gross rate for a teacher/lecturer for a fixed 45 min course</th>
        <th>Gross rate for an animator for a fixed 60 min course</th>
      </tr>
      <tr 
        v-for="(row,index) in tableRows"
        :key="index"  
      >
        <td>{{ row.studentsNum }}</td>
        <td>{{ row.teacherWage }}</td>
        <td>{{ row.animatorWage }}</td>
      </tr>
    </table>
    <li>
      Due to the in-person classes conducted at the institutions indicated by the Principal in accordance with § 2 section 3, the Contractor is not entitled to additional compensation for travel or for performing additional tasks related to the preparation, organization, and reporting of the classes.
    </li>
    <li>
        For conducting demonstration classes, the basic rate applies.
    </li>
    <li>
        An active participant in classes is considered to be a person who has attended at least one fixed class and is an active payer.
    </li>
    <li>
      The parties agree on a monthly billing period for the services provided. The Contractor will issue a VAT invoice after the end of the billing period.
    </li>
    <li>
        The total monthly remuneration will be based on the hourly rate resulting from para. 1-3 of this section and the number of lessons conducted in a given month, based on the statement and documentation referred to in para. 8 of this section. If one lesson, according to the schedule, lasts more or less than 60 minutes, the remuneration rate for one lesson will be proportionally reduced or increased. The Contractor is not entitled to additional remuneration for performing additional activities related to the preparation, organization, and reporting of classes. In the case of in-person classes, Table No. 1: Rate Schedule for In-Person Classes in Primary Schools under the Back to School project applies.
    </li>
    <li>
        The Contractor is obliged to prepare and submit to the Principal electronically:
      <ol type="a">
            <li>
            A statement of the number of hours worked in a given month, generated from the timekeeping tools provided by the Principal, no later than the last working day of the month.
            </li>
            <li>
            Documentation confirming the completion of classes each time, by the end of the day on which the classes took place, in particular, class registers and/or attendance lists of students. Verified by the Principal, the statement and documentation will form the basis for the Contractor's remuneration payment. 
            </li>
      </ol>
      Verified by the Principal, the statement and documentation will form the basis for the Contractor's remuneration payment. 
    </li>
    <li>
      Payment of remuneration for each month of service provision will be made within 14 days from the issuance of the VAT invoice (according to the date indicated on the invoice). The remuneration is payable by bank transfer to the account number specified on the invoice issued by the Contractor and accepted by the Principal. A condition for the payment of the remuneration is the completion of the contract's subject matter, the submission of a report on its execution according to the guidelines of Tutore Poland, and the issuance and submission of an electronic invoice to the designated person. The Contractor declares that the bank account specified on the VAT invoice will be a settlement account used exclusively for the purposes of settlements related to the business activities conducted by the Contractor and will be a bank account registered in the electronic register maintained by the Head of the National Revenue Administration as part of the so-called 'white list of taxpayers' (hereinafter referred to as the 'Register'), as referred to in the VAT Act. If, prior to the payment, the Principal becomes aware that the bank account is not listed in the Register, the Principal shall be entitled to make the payment to the Contractor's bank account listed in the Register, which will constitute fulfillment of the Principal's obligation.
    </li>
    <li>
    The Principal may reduce the gross remuneration by up to 15% for a given month in case of non-compliance with the contract terms, particularly for: not checking attendance lists and/or marking class statuses in the system on time, not adhering to declared availability, being late for classes, not responding to emails, and not answering phone calls from persons designated by the Principal for contact, justified complaints from parents about the quality of the lessons conducted, failure to assess children in daily reports no later than the end of the day on which the classes took place/planned, not maintaining personal culture rules during classes and in contact with persons designated by the Principal, failure to comply with guidelines regarding the program and quality of educational classes specified by the Principal.
    </li>
  </ol>
  <br>

  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 7 Confidential Information</strong>
  </p>
  <ol>
    <li>
        Confidential Information refers to any information provided to the Contractor by the Principal or obtained by the Contractor in any other way in connection with the performance of this contract, including technical, technological, organizational, or other information of economic value related to the Principal's activities and Clients, in particular, teaching materials used by the Principal, a database of contact details to the Principal's Clients (including clients who terminated cooperation with the Principal within 12 months after the end of the contract), computer systems, and other information obtained from the Principal during the contract.
    </li>
    <li>
        The Contractor agrees that the Confidential Information obtained under this contract will be kept confidential by the Contractor and used solely to perform this contract. Confidential Information will not be used for other purposes nor disclosed or made available to third parties, in whole or in part. The obligation to maintain confidentiality applies to Confidential Information obtained by the Contractor from the Principal in written form and disclosed to the Contractor verbally, visually, electronically, or otherwise. The Contractor undertakes to keep the Confidential Information received in confidence and not disclose it to anyone without the Principal's written consent.
    </li>
    <li>
        The Contractor, after the termination of cooperation between the Parties or before its termination - at any request of the Principal - will be obliged to return to the Principal within 3 days all Confidential Information, along with documentation and other media on which they have been recorded, as well as copies of documentation or media containing such Information. The Contractor agrees to delete all received or created materials from computer memories and other devices in a manner preventing their recovery and use in the future in any form.
    </li>
    <li>
        In case of violation by the Contractor of the provisions of the preceding paragraphs, particularly by unauthorized disclosure or sharing of materials and Confidential Information, the Contractor will be obliged to pay the Principal a contractual penalty of PLN 5,000.00 (in words: five thousand zlotys) for each such violation. Such a penalty will be payable within 14 days from the date of the Principal's statement on charging the Contractor with a contractual penalty.
    </li>
    <li>
        If the damage or lost benefits suffered by the Principal as a result of the Contractor's violation of the provisions of this contract exceed the amount of the stipulated contractual penalty indicated in para. 4 of this section, the Principal may claim additional compensation based on general principles resulting from the Civil Code.
    </li>
    <li>
        A violation of the principles described in this contract also includes any use of the Principal's teaching materials for the Contractor's private purposes and for teaching persons who are not Clients of the Principal.
    </li>
    <li>
        Regardless of the expiration or termination of this contract, the Contractor's obligation to maintain the confidentiality of Confidential Information remains in force for a period of 5 years.
    </li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 8 Non-Compete Clause</strong>
  </p>
    <ol>
      <li>
        The parties understand competitive activity within the meaning of this section to include: offering or providing any educational services by the Contractor in any form to the Principal's clients who entered into an agreement with the Principal no later than the expiration of this contract.
    </li>
    <li>
        Competitive activity also includes:
      <ol type="a">
        <li>
            Providing work by the Contractor to an entity conducting competitive activities against the Principal; providing services by the Contractor under any civil law agreement to an entity conducting competitive activities against the Principal,
        </li>
        <li>
            Running a business by the Contractor conducting competitive activities against the Principal, including through a third party,
        </li>
        <li>
            Being a partner in a company conducting competitive activities against the Principal,
        </li>
        <li>
            Serving on the boards of entities conducting competitive activities against the Principal,
        </li>
        <li>
            Acting as an agent, attorney, or proxy for persons conducting competitive activities against the Principal.
        </li>
      </ol>
    </li>
    <li>
        The Contractor agrees during the collaboration described in this contract not to engage in competitive activities during the contract period against the Principal's activities according to the definition presented in para. 1 of this section.
    </li>
    <li>
        If a Client who is a current Client of the Principal themselves proposes cooperation with the Contractor, the Contractor is obliged to inform the Client of the non-compete clause mentioned above and refuse to cooperate and is obligated to inform the Principal of the situation.
    </li>
    <li>
        The Principal reserves the right to check whether the Contractor is properly complying with the provisions of this section.
    </li>
    <li>
        For each violation of the non-compete clause referred to in this contract, the Principal may charge the Contractor a penalty of PLN 20,000.00 (in words: twenty thousand zlotys). In such a case, the Principal may also seek compensation exceeding the stipulated contractual penalty.
    </li>
    </ol>
    <br>

    <p align="center" style="margin-bottom: 0px;">
    <strong>§ 9 Standards for the Protection of Minors</strong>
  </p>
  <p>The Contractor declares that they have familiarized themselves with the provisions of the document 'Standards for the Protection of Minors at Tutore Sp. z o.o.' introduced by the Principal under the Act of May 13, 2024, on the Protection of Minors (Journal of Laws 2024, item 560) and commits to complying with it. Any violation of the regulations will be considered a material breach of the obligations under this agreement and may result in its immediate termination.</p>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 10 Entire Agreement and Amendments</strong>
</p>
<ol>
    <li>
        This agreement supersedes and replaces any and all prior written or oral arrangements, agreements, understandings, and contracts between the Parties concerning the matters covered by this agreement, which are hereby rendered null and void.
    </li>
    <li>
        The Parties declare that, apart from this agreement, no additional arrangements or agreements exist between them regarding the subject matter of this agreement.
    </li>
    <li>
        Any amendments to this agreement must be made in writing to be valid.
    </li>
    <li>
        The termination of this agreement must be made in writing to be valid. The Principal’s statement may also be submitted in document form, which will be considered as meeting the requirement of a written statement.
    </li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
    <strong>§ 11 Disputes and Jurisdiction</strong>
</p>
<p>
    The Parties declare that they will make every effort to resolve any disputes arising from this agreement amicably. In the event of disputes that cannot be resolved amicably within 14 days from the date of receipt of a written notice from the other party requesting such amicable resolution, the disputes shall be submitted to the court competent for the Principal’s registered office. The provisions of the preceding sentences do not constitute an arbitration clause.
</p>
<br>

<p align="center" style="margin-bottom: 0px;">
    <strong>§ 12 Number of Copies of the Agreement</strong>
</p>
<p>
    This agreement has been drawn up in two identical copies, one for each party.
<br>
</p>
<br>
  
   <div>
    <p class="underline">Attachments forming an integral part of the contract:</p>
    <ol>
      <li class="underline">Consent for Image Use</li>
      <li class="underline">GDPR Information Clause</li>
      <li class="underline">Authorization to Process Personal Data</li>
      <li class="underline">Information on Online Class Monitoring</li>
      <li class="underline">Contractor's Statement</li>
      <li class="underline">General BHP Rules for Office Work</li>
      <li class="underline">CODE OF ETHICS</li>
      
    </ol>
  </div>
  
  <div class="cointainer" style="margin-top: 30px;">
      <div class="left-cointainer">
          <span style="margin-left: 0%;">{{zamawiajacy}}</span><br>
          <span style="margin-left: 0%;">(Principal's Signature)</span>
      </div>
      <div class="right-cointainer">
          {{imieNazwisko}}<br>
          <span style="margin-left: 0%;">(Contractor's Signature)</span>
      </div>
  </div>
  <br><br>
  
  
  <div>
     <p><strong>Attachment No. 1. CONSENT FOR IMAGE USE</strong></p>
     <p>I hereby declare that I give Tutore Poland Sp. z o.o., with its registered office in Łódź at ul. Piotrkowska 157A, 90-440, KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567, (hereinafter referred to as Tutore Poland Sp. z o.o.) consent to the free recording and unlimited in time and territory multiple use and distribution of my image in the form of a photograph in connection with the performance of the contract of mandate for placement in the company's email signature. The image will be used exclusively for the duration of the contract in the form of a photograph in email correspondence sent on behalf of the Principal.</p>
     <p>I also declare that I give Tutore Poland Sp. z o.o. consent to the free recording and unlimited in time and territory multiple use and distribution of my voice or statements recorded during the performance of this service contract using VoIP (Voice over Internet Protocol) phones.</p>
     <p>This consent covers the following fields of exploitation: use, recording, processing, and reproduction of the photographs/recordings made, distribution of copies on which my image or voice has been recorded, and the multiplication of the image/voice by any available techniques and methods, dissemination and publication, in materials used by Tutore Poland's activities, particularly in training, educational, and promotional materials in any form.</p>
     <p>Tutore Poland Sp. z o.o. holds the exclusive right to decide on the form and timing of the use of my image, voice, and statements in whole or in any fragments. The image may be used for various forms of electronic image processing, cropping, and composition without the obligation to approve the final product, but not in offensive or generally unethical forms.</p>
     <div style="page-break-before: always;">
    <p><strong>Attachment No. 2. INFORMATION CLAUSE</strong></p>
    <p class="p-margin-ten">Information clauses from Article 13 of the GDPR</p>
    <p class="p-margin-ten">Pursuant to Article 13(1) and (2) of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation), OJ L 119, 04.05.2016, p. 1, hereinafter "GDPR", we inform you that:</p>
    <p class="p-margin-ten">The controller of your personal data is Tutore Poland Sp. z o.o., with its registered office in Łódź at ul. Piotrkowska 157A, 90-440, hereinafter: "Data Controller".</p>
    <p class="p-margin-ten">You may contact the Data Controller by writing to the address: Tutore Poland Sp. z o.o, ul. Piotrkowska 157A, 90-440, or via email at kadry@tutore.eu, and also through contact with the Data Protection Officer at the email address: mlokaj@mlkancelaria.com</p>
    <p class="p-margin-ten">The Data Controller processes personal data for the following purposes:</p>
    <ol type="a">
      <li>to establish cooperation - Article 6(1)(b), (f) GDPR,</li>
      <li>to ensure communication between the Parties (email address, phone number) - Article 6(1)(b), (f) GDPR,</li>
      <li>to fulfill rights and obligations under the service contract - Article 6(1)(b), (c), (f) GDPR,</li>
      <li>to maintain a correspondence register - Article 6(1)(c), (f) GDPR,</li>
      <li>to record the course of cooperation (including payment processing) - Article 6(1)(b), (c) GDPR,</li>
      <li>to pursue claims and rights - Article 6(1)(b), (f) GDPR,</li>
      <li>to fulfill tax obligations - Article 6(1)(b), (c) GDPR,</li>
    </ol>
    <br>
    <p class="p-margin-ten">The recipients of personal data are entities entrusted by the Data Controller with the processing of personal data, in particular: providers of technical and organizational services, providers of accounting, HR, legal, and advisory services, banks (payment processing), public authorities in the framework of obligations related to the Data Controller's business activities.</p>
    <p class="p-margin-ten">The Data Controller does not transfer personal data outside the European Economic Area.</p>
    <p class="p-margin-ten">Personal data will be stored for the duration of the contract, and thereafter for the period required by generally applicable law, in particular: for the pursuit of claims (limitation period for claims), for keeping accounting records and tax documentation (5 years from the end of the calendar year in which the tax obligation arose).</p>
    <p class="p-margin-ten">The person whose data is being processed has the right to access their data and receive a copy, the right to rectify (correct) their data, the right to delete data, the right to withdraw consent, the right to restrict processing, the right to be forgotten, the right to object, the right to data portability, and the right to lodge a complaint with the Data Protection Authority.</p>
    <p class="p-margin-ten">Providing your personal data and consent to their processing and dissemination of your image is voluntary but is a necessary condition for establishing cooperation and possibly entering into a written contract, as well as for the Data Controller to fulfill its rights and obligations.</p>
    <p class="p-margin-ten">In the activities of the Data Controller, there is no automated decision-making, including profiling, using the personal data collected.</p>
    <p class="p-margin-ten">The scope of data subject to processing: name and surname, email address, phone number, image, PESEL.</p>
    <p style="margin-bottom: 5px;">{{ imieNazwisko }}</p>
    <p style="margin-bottom: 0px;">Signature</p>
    </div>
    </div>
  
  <div style="page-break-before: always;">
    <div class="cointainer" style="margin-top: 60px;">
      <div class="left-cointainer">
        <p><em>Attachment No. 3</em></p>
      </div>
      <div class="right-cointainer">
        <p style="margin-bottom: 10px; font-size: 14px;">
      Łódź, {{ aktualnaData() }} 
        </p>
      </div>
  </div>
    
    
  <p align="center" class="subheading" style="margin-bottom: 10px;">
    <strong>
      Supplementary Authorization<br>
      to process personal data in a<br>
      paper and electronic collection
    </strong>
  </p>
  <p class="p-margin">
    Based on Article 29 of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation), hereinafter GDPR:
  </p>
  <p class="p-margin">
    from the date of signing this authorization by both parties
  </p>
  <p class="p-margin">
    I authorize Mr./Ms. {{ imieNazwisko }} Contractor of Tutore Poland Sp. z o.o.
  </p>
  <p class="p-margin">
    performing a service contract by conducting classes in the subject {{ przedmiot }} in the education department
  </p>
  <p class="p-margin">
    to process personal data contained in the following personal data collections:
  </p>
    <ol type="a">
      <li>in electronic form:
        <ul>
          <li>
            personal data collection of Clients: parents (legal guardians) of children, youth, and adults using the services offered by Tutore Poland – name and surname, home address, contact phone number, email address,
          </li>
          <li>
            personal data collection of Clients: children, youth, and adults using the services offered by Tutore Poland – name and surname, home address, contact phone number, email address.
          </li>
        </ul>
      </li>
    </ol>
  <p class="p-margin">
    for the purposes of viewing, entering, modifying, deleting, and archiving personal data contained in the above-mentioned collections.
  </p>
  <p class="p-margin">
    This authorization does not authorize further authorizations and expires on the date of termination of the service contract, and may be amended or revoked at any time.
  </p>
  <p>
    I oblige you to process the personal data contained in the above-mentioned personal data collections within the scope and in the manner required to fulfill your duties towards the Principal - Data Controller. I oblige you to process personal data in accordance with the authorization granted, the GDPR, and the internal regulations in force at Tutore Poland Sp. z o.o. regarding the protection of personal data.
    <br>
    Violation of the above-mentioned obligations may result in criminal liability and constitutes grounds for terminating the service contract.
  </p>
  
  <div class="container" style="page-break-before: always;">
      <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
        <tr>
          <td id="oswiadczenie">
            <p align="center" class="subheading"><strong>CONTRACTOR'S STATEMENT</strong></p>
            <ol>
          <li>I, the undersigned, declare that:
          <ol type="a">
            <li>
              I have familiarized myself with the content and scope of the authorization and acknowledge it,
            </li>
            <li>
              the content of the authorization is understandable and clear to me, and any doubts have been clarified by an authorized person in a comprehensive manner,
            </li>
            <li>
              I undertake to process personal data contained in the above-mentioned personal data collections within the scope and in the manner required to fulfill my duties towards the Principal,
            </li>
            <li>
              I undertake to process personal data in accordance with the authorization granted, the GDPR, and the internal procedures in force at the Principal, including the Privacy Policy,
            </li>
            <li>
              I undertake to keep confidential the personal data to which I have or will have access in connection with performing duties for Tutore Poland Sp. z o.o., and to keep confidential the methods of securing personal data, even after the revocation or change of the authorization, as well as after the termination of the service contract.
            </li>
          </ol>
          </li>
          </ol>
            <div class="right-cointainer" style="float: right; margin-top: 20px;">
          <span style="font-size: 14px;">{{imieNazwisko}}</span>
          <br>
          <span>clear signature of the Contractor</span>
          </div>
        </td>
      </tr>
    </table>
    </div>
  
  <p class="subheading p-margin" style="text-align: center;">
    {{ zamawiajacy }} 
    <br>
    <strong>on behalf of the Administrator</strong>
  </p>
  <br>
  <p>This authorization was revoked on the day the service contract was terminated.</p>
  </div>
  
  <div style="page-break-before: always;">
    <p><em>Attachment No. 4</em></p>
    <p class="subheading" style="margin-bottom: 0px;"><strong>Information on the monitoring of online classes and recording of internal online trainings</strong></p>
    <br>
    We inform you that Tutore Poland Sp. z o.o. uses technical means enabling the monitoring of conducted online classes and the recording of internal online trainings. The monitoring covers devices recording images and sound, used by the user to conduct online classes, i.e., the Clickmeeting platform or Zoom application, and in the case of internal online training, the Zoom application. Tutore Poland Sp. z o.o. applies monitoring for the following purposes: ensuring the highest standards of service in the lessons conducted by employees/contractors, ensuring the correctness of the performed tasks, and possibly improving the quality of lessons, protecting the company's interests in disputes with clients (evidence material), and in the case of internal online training, to ensure the possibility of providing recordings to new employees/contractors. We inform you that: the audiovisual and sound monitoring system for online classes consists of the recording system of the Clickmeeting or Zoom platform and a server on which online classes are recorded. Access to the recording of online classes is granted to persons authorized by the Management Board of Tutore Poland Sp. z o.o., i.e., Call Center Manager, Process Management Director, Infoline Teamleader, persons who have access to the recorded image are aware of their responsibility for the protection of personal data and have appropriate authorization issued by the Data Controller. During the recording, personal data in the form of voice, image, and name of the employee/contractor conducting the class or training is processed. The Data Controller of the personal data obtained in the course of monitoring online classes and during the recording of internal online training is Tutore Poland Sp. z o.o., which in connection with the above-mentioned activity provides below the required information clause concerning the processing of personal data.
  </div>
  
  <div style="margin-top:40px; page-break-before: always; font-size: 10px;">
    <p align="right" style="font-size: 14px; margin-bottom: 0;">
          Łódź, {{ aktualnaData() }}
        </p>
          <p style="font-size: 14px; margin-bottom: 0;">{{imieNazwisko}}</p>
          <p style="font-size: 14px;">Contractor's Name and Surname</p>
  <p align="center" class="subheading">
    <strong>INFORMATION ON PERSONAL DATA PROCESSING</strong>
  </p>
  <ol>
    <li>
      We inform you that the Data Controller of your personal data as a Contractor is Tutore Poland Sp. z o.o. with its registered office at ul. Piotrkowska 157A, 90-440 Łódź, KRS number: 0000867745, NIP: 7272846163, REGON: 387448002, tel. 500 965 135, info@tutore.eu
    </li>
    <li>
      By presenting you with this information on personal data processing, the Data Controller fulfills the legal obligation under Article 15(1) of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation), hereinafter GDPR.
    </li>
    <li>
      The Data Controller obtains information about you due to a statutory obligation, which is necessary for the effective implementation of the cooperation process. For personal data not affected by the statutory necessity condition - providing them is voluntary.
    </li>
    <li>
      Your personal data is processed for the following purposes, on the following basis, and for the following period:
      <ol type="a">
        <li>
          conclusion and performance of a civil law contract – for the purpose of fulfilling the obligation under the Civil Code (Article 6(1)(b), (c), (f) GDPR) – for the duration of the cooperation,
        </li>
        <li>
          calculation and payment of remuneration – for the purpose of fulfilling the obligation under the Civil Code (Article 6(1)(c), Article 9(2)(b) GDPR) – for the duration of the cooperation,
        </li>
        <li>
          deductions from remuneration – for the purpose of fulfilling obligations regarding deductions from remuneration under the Code of Civil Procedure, the Act on Administrative Enforcement Proceedings, the Act on Court Bailiffs (Article 6(1)(c) GDPR) – for the period prescribed by generally applicable law,
        </li>
        <li>
          fulfillment of tax obligations – for the purpose of fulfilling the obligations of the taxpayer under the Tax Ordinance, the Personal Income Tax Act, and other tax laws (Article 6(1)(c) GDPR) – for a period of 5 years from the end of the calendar year,
        </li>
        <li>
          fulfillment of obligations to the Social Insurance Institution (ZUS) – for the purpose of fulfilling the obligations of the payer of social and health insurance contributions under the Act on Pensions from the Social Insurance Fund, the Act on the Social Insurance System, and the Act on Health Care Services Financed from Public Funds (Article 6(1)(c), Article 9(2)(b) GDPR) – for a period of 5 years from the end of the calendar year,
        </li>
        <li>
          fulfillment of accounting obligations – for the purpose of fulfilling obligations under the Accounting Act, the Tax Ordinance, and the Corporate Income Tax Act (Article 6(1)(c) GDPR) – for a period of 5 years from the end of the financial year in which the event occurred,
        </li>
        <li>
          physical security of buildings, premises, and property of the Data Controller – based on the legitimate interest of the Data Controller (Article 6(1)(f) GDPR) – for the duration of the cooperation,
        </li>
        <li>
          ensuring the highest standards of service for lessons conducted by Collaborators via the ClickMeeting or Zoom platform, ensuring the correctness of the performed tasks, and possibly improving the quality of lessons, protecting the company's interests in disputes with clients (evidence material) by monitoring and recording online courses – based on the voluntary consent of the person being recorded (Article 6(1)(a) GDPR) – The image and voice of the Collaborator will be processed for a period of 3 months. If the recordings of the registered classes constitute evidence in proceedings conducted under the law or the Data Controller has learned that they may constitute evidence in proceedings, this period is extended until the final conclusion of the proceedings. After these periods, recordings containing personal data are destroyed,
        </li>
        <li>
          ensuring the possibility of providing recordings to new Employees and Collaborators, recording online trainings conducted via the Zoom platform – based on the voluntary consent of the person being recorded (Article 6(1)(a) GDPR) – The image and voice of the Collaborator will be processed until the consent is withdrawn. In the event of withdrawal of consent, recordings containing personal data are destroyed,
        </li>
        <li>
          ensuring the highest standards of customer service quality, for training purposes – enabling the improvement of service quality, protecting the company's interests in disputes with clients (evidence material), ensuring the safety of Collaborators in the event of undesirable and dangerous incidents from Clients (e.g., criminal threats) by monitoring telephone conversations with Clients of the Data Controller – based on the legitimate interest of the Data Controller (Article 6(1)(f) GDPR) – for a period of up to 3 months. If recordings of registered telephone conversations constitute evidence in proceedings conducted under the law or the Data Controller has learned that they may constitute evidence in proceedings, this period is extended until the final conclusion of the proceedings. After these periods, recordings containing personal data are destroyed,
        </li>
        <li>
          creating photo reports from camps for children and youth on a pendrive for Clients, Facebook fan page, and the website www.musicandmore.pl – based on the voluntary consent of the person being recorded (Article 6(1)(a) GDPR) – The image and voice of the Collaborator will be processed until the consent is withdrawn. In the event of withdrawal of consent, recordings containing personal data are destroyed,
        </li>
        <li>
          pursuing claims or defending against claims – based on the legitimate interest of the Data Controller (Article 6(1)(f) GDPR) consisting of participating in legal proceedings – in the event of ongoing proceedings for the duration of the proceedings until their final conclusion and for the period prescribed by generally applicable law.
        </li>
      </ol>
    </li>
    <li>
      The recipients of your personal data will be:
      <ul>
        <li>
          public administration bodies (e.g., Social Insurance Institution, Tax Offices) – by virtue of appropriate legal provisions;
        </li>
        <li>
          healthcare facilities for purposes related to occupational medicine;
        </li>
        <li>
          external entities providing and supporting the Data Controller's IT systems (both general IT infrastructure, email, and IT systems used by the Data Controller for HR and financial services or document flow related to employment) – based on appropriate data processing agreements and ensuring that these entities use adequate technical and organizational measures to protect data,
        </li>
        <li>
          accounting offices:
        </li>
        <li>
          banks – to pay wages and other monetary benefits to the Data Controller with the Contractor's consent to a bank account;
        </li>
        <li>
          contractors – to enable contractors (potential and current) to contact or to fulfill ongoing contracts related to the position held by the Contractor;
        </li>
        <li>
          collaborators of the Data Controller who provide services to Tutore Poland Sp. z o.o., to enable collaborators to contact the Contractor,
        </li>
        <li>
          entities providing additional services for Contractors, only if the Contractor uses these services.
        </li>
        <li>
          insurance institutions
        </li>
        <li>
          foreign administration organizations in EU countries where the contract is performed (applies to contracts performed abroad)
        </li>
        <li>
          training and BHP obligations-fulfilling entities (if there is no BHP unit at the Data Controller)
        </li>
      </ul>
    </li>
    <li>
      You have the right to:
      <ol type="a">
        <li>
          <strong>access data</strong> — to obtain confirmation from the Data Controller whether your personal data is being processed. If data is being processed, you have the right to access it (Article 15 GDPR);
        </li>
        <li>
          <strong>receive a copy of the data</strong> — to obtain a copy of the data being processed, with the first copy being free of charge, and the Data Controller may charge a reasonable fee for subsequent copies, based on administrative costs (Article 15(3) GDPR);
        </li>
        <li>
          <strong>rectification</strong> — to request the rectification of personal data that is inaccurate or the completion of incomplete data (Article 16 GDPR);
        </li>
        <li>
          <strong>erasure of data</strong> — to request the erasure of personal data if the Data Controller no longer has a legal basis for processing it, or the data is no longer necessary for the purposes of processing (Article 17 GDPR);
        </li>
        <li>
          <strong>restriction of processing</strong> — to request the restriction of the processing of personal data (Article 18 GDPR) when:
          <ol type="i">
            <li>
              you contest the accuracy of the personal data — for a period enabling the Data Controller to verify the accuracy of the data,
            </li>
            <li>
              the processing is unlawful, and you oppose the erasure of the data and request the restriction of its use instead,
            </li>
            <li>
              the Data Controller no longer needs the data, but you need it to establish, exercise, or defend claims;
            </li>
            <li>
              you have objected to processing — pending verification whether the legitimate grounds of the Data Controller override your grounds for objection;
            </li>
          </ol>
        </li>
        <li>
          <strong>data portability</strong> — to receive the personal data concerning you that you have provided to the Data Controller, in a structured, commonly used, machine-readable format, and to request that those data be transmitted to another Data Controller if the data is processed on the basis of your consent or a contract with you, and if the data is processed by automated means (Article 20 GDPR);
        </li>
        <li>
          <strong>objection</strong> — to object to the processing of personal data for the legitimate purposes of the Data Controller, for reasons related to your particular situation, including profiling. The Data Controller will assess whether there are compelling legitimate grounds for processing that override your interests, rights, and freedoms, or for establishing, exercising, or defending claims. If, according to the assessment, your interests are more important than the interests of the Data Controller, the Data Controller will be obliged to cease processing data for those purposes (Article 21 GDPR);
        </li>
        <li>
          <strong>right to lodge a complaint with a supervisory authority</strong> – the President of the Personal Data Protection Office, if you consider that the processing of your personal data violates the regulations. Complaints can be filed:
          <ul>
            <li>
              in writing to the address: ul. Stawki 2, 00-193 Warsaw,
            </li>
            <li>
              electronically via the ePUAP platform.
            </li>
          </ul>
        </li>
      </ol>
    </li>
    <li>
      In the course of personal data processing, no exclusively automated decision-making or profiling, referred to in Article 22(1) and (4) GDPR, takes place, meaning that no decisions concerning you will be made automatically, and no profiles concerning you will be created.
    </li>
    <li>
      You are obliged to inform the Principal of any changes regarding your personal data provided to the Principal in accordance with the Contract.
    </li>
  </ol>
  </div>
  
  <div style="page-break-before: always;">
    <div class="container">
      <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
        <tr>
          <td id="oswiadczenie">
            <p align="center" class="subheading"><strong>CONTRACTOR'S STATEMENT</strong></p>
            <ol>
          <li>I, the undersigned, declare that:
          <ol type="a">
            <li>I have read the Information on monitoring online classes and recording internal online trainings and the Information Clause and acknowledge it,</li>
            <li>The content of the Information and Clause is understandable and clear to me, and any doubts have been clarified by an authorized person in a comprehensive manner.</li>
            </ol>
            </li>
            <li>In a completely voluntary manner, I consent to the processing of my personal data for the purposes specified in the Information on monitoring online classes and recording internal online trainings.</li>
            <li>I have been informed that my personal data is processed based on my voluntary consent and that I have the right to withdraw my consent at any time, with the withdrawal of consent taking effect from the moment of its submission and without affecting the processing of my personal data for purposes related to the conduct of the study before the withdrawal of consent.</li>
            <li>Under Article 81(1) of the Copyright and Related Rights Act, I consent to the dissemination of my image by Tutore Poland Sp. z o.o. for the purposes specified in the Information on monitoring online classes and recording internal online trainings.</li>
            </ol>
            <div style="float: right; margin-top: 20px;">
          <span style="font-size: 14px;">{{imieNazwisko}}</span>
          <br>
          <span>clear signature of the Contractor</span>
          </div>
        </td>
      </tr>
    </table>
    </div>
    </div>
  
  <div style="margin-top:5px;page-break-before: always;">
    <p><em>Attachment No. 5</em></p>
    <p align="center" class="subheading"><strong>Contractor's Declaration</strong></p>
  
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
    <tbody>
  
    <tr>
    <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
    <p class="cell-in-first-table"><span><strong>PERSONAL DATA</strong></span></p>
    </td>
    <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
    <p class="cell-in-first-table"><span><strong>TO BE COMPLETED</strong></span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Date</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{data}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>First and Last Name</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{imieNazwisko}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>PESEL Number</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{pesel}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Series and number of ID card (please provide in case of no PESEL number)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{nrDowodu}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Citizenship</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{obywatelstwo}}</span></p>
    </td>
    </tr>

    <tr v-if="obywatelstwoOIZ">
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>I have a center of personal or economic interest (center of vital interests) in the territory of the Republic of Poland:</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{obywatelstwoOIZ}}</span></p>
    </td>
    </tr>

    <tr v-if="obywatelstwoDNI">
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>I reside in the territory of the Republic of Poland for more than 183 days in a calendar (tax) year:</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{obywatelstwoDNI}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Phone number</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{nrTelefonu}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Email address</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{email}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Residence address</span><br><span class="caption"> (street, house number, postal code, city)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table bigCell"><span>{{zamieszkany}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Mailing address</span><br><span class="caption"> (street, house number, postal code, city)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{korespondencyjny}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Tax Office <br>(according to the residence address)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table bigCell"><span>{{urzadSkarbowy}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Bank account number</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{nrRachunku}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
    <p class="cell-in-first-table"><span><strong>I DECLARE THAT:</strong></span></p>
    </td>
    <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
    <p class="cell-in-first-table"><span><strong>ANSWERS: “YES” or “NO”<br>(or description if required)</strong></span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>1. I am a pensioner</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{emeryt}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>2. I am a disability pensioner</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{rencista}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>3. I have a disability certificate</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{orzeczenieNiepelnosprawnosc}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>3.1. If "YES" is indicated, please specify the degree of disability</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{stopienNiepelnosprawnosc.replace(/\s*\(.*$/, '')}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>4. I am a student under the age of 26<br>(if "YES" is indicated, please skip items 5, 6, 7)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{student}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>5. I request voluntary sickness insurance<br>(only in case of being covered by pension and disability insurance)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{chorobowe.replace(/\s*\(.*$/, '')}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>6. I am employed under an employment contract or service contract<br>(If "YES" is indicated, please complete the following information)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{zatrudnionyUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>6.1. Name and address of the employer</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{nazwaUmowaPraca}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>6.2. Remuneration under the employment/service contract<br>is equal to or greater than the national minimum wage</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
    </td>
    </tr>

    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>6.3. I apply for voluntary pension and disability insurance (only if the answer is YES in items 6 and 6.2):</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{wniosekUbezpieczenie}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>7. I am covered by social insurance from another title<br>than the employment/service contract with Tutore Poland Sp. z o.o.</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{ubezpieczenieUmowaPraca}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>7.1. In case of answering: YES, please specify the title of insurance</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{tytulUbezpieczenieUmowaPraca}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
    <p class="cell-in-first-table"><span><strong>
    Filling out the above declaration means a declaration of the conformity of the data provided with the legal and factual state, as well as awareness of criminal liability for false testimony or concealment of the truth.
    <br/>
    I undertake to inform the Employer in case of a change of the above data within 7 days from the date of the change. I consent to the provision to the Administrator of my personal data of my phone number, email address, and mailing address in the Contractor's Declaration for the purpose of sending annual tax declarations.
    <br/>
    </strong></span></p>
    </td>
    </tr>
  
    </tbody>
    </table>
  </div>
    
  <div style="margin-top: 5px;page-break-before: always;">
    <p><em><b>Attachment No. 6</b></em></p>
    <p class="subheading" style="margin-bottom: 0px;"><strong>GENERAL SAFETY RULES FOR ADMINISTRATIVE AND OFFICE WORK</strong></p>
    <br>
    <p>Safe working conditions are ensured when:</p>
    <ul>
      <li>A sufficiently large workspace is provided (at least 2m of free floor space).</li>
      <li>Proper lighting is provided (depending on the nature of the work, at least 300lx).</li>
      <li>Adequate ventilation of the room is provided (natural or mechanical); relative humidity should not be less than 40%.</li>
      <li>Adequate heating is provided during the autumn-winter period (min. +18°C)</li>
      <li>Hygienic and sanitary facilities are available and in good condition, as well as the good technical condition of furniture, equipment, and other devices.</li>
    </ul>
    <p>Basic activities to be performed before starting work:</p>
    <ul>
      <li>Plan the sequence of tasks, prepare the necessary documents and programs.</li>
      <li>Set up the monitor screen in relation to light sources to reduce glare and light reflections.</li>
      <li>Check the technical condition of furniture, equipment, devices, and lighting at the workplace.</li>
      <li>Thoroughly familiarize yourself with the operating and safety instructions for the electrical and electronic equipment used during work (computer, printer, etc.).</li>
      <li>Adjust the chair and prepare the workstation to suit yourself.</li>
    </ul>
    <p>Activities to be performed during work:</p>
      <ul>
      <li>Maintain order and cleanliness at the workplace.</li>
      <li>Exercise caution when using electrical equipment.</li>
    </ul>
    <p>Prohibited activities:</p>
    <ul>
      <li>Allowing unauthorized persons to use the equipment.</li>
      <li>Opening covers during the operation of devices.</li>
      <li>Using defective or damaged equipment or electrical installations (e.g., damaged insulation on wires, broken plugs or sockets, makeshift wire connections). </li>
    </ul>
    <p>Final remarks:</p>
    <ul>
      <li>
          When working constantly at a computer, you should:
          <ul>
              <li>alternate work related to operating a visual display unit with other types of work that do not strain the visual system and are performed in other body positions – not exceeding 1 hour of uninterrupted work at the visual display unit, or</li>
              <li>at least a 5-minute break, included in the working time, after every hour of work at the visual display unit.</li>
          </ul>
      </li>
    </ul>
    <p style="margin-top: 30px;">I declare that I have read and accept the above safety rules for administrative and office work.</p>
    <div style="margin-top: 40px; font-size: 10px;">
      <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
      <p style="font-size: 14px;">Contractor's Signature</p>
    </div>
  </div>

  <div style="margin-top: 5px;page-break-before: always;">
    <p><em><b>Attachment No. 7 CODE OF ETHICS</b></em></p>
     Introduction
     <p>At the Tutore Group, we believe that ethical and responsible conduct is the foundation of trust in both education and business. This Code of Ethics outlines the values and principles that guide our daily operations. It defines the standards of conduct that we aim to build and develop together with ourbusiness partners. The Tutore Group operates in a professional and socially responsible manner, ensuring compliance with ethical standards, applicable laws, and environmental protections. To maintain these high standards, we select business partners who align with the values presented in this Code. The Group supports its business partners in adhering to these principles by providing guidance and clarification for any inquiries.</p>
     Group Operating Standards
     <p>Our activities are rooted in integrity, responsibility, and quality — the key values of the education sector. In relations with business partners and clients, Tutore Group entities adhere to the principles of equal treatment, transparency, and openness. The Group places a strong emphasis on compliance with regulations regarding fair competition, consumer protection, and personal data privacy. We are commited to continuous improvement of the quality of our services through innovation, development, and process optimization. The Group systematically enhances its internal control and audit framerorks to ensure the highest operational standards across all Group companies.</p>
     Human Rights and Children’s Rights
     <p>The Tutore Group is commited to respecting fundamental human rights and freedoms, including the right to life, health, personal integrity, dignity, and liberty. We uphold the right to freedom of thought and speech, as well as the right to individual development. As an educational organization, we prioritize the protection of minors and confirm that the Group’s entities prohibit and do not engage in any form of child labor or forced labor within our operations</p>
     Employee Rights
     <p>At the Tutore Group, we strive to provide a safe, supportive, and inclusive environment for all employees and collaborators. We comply with labor law regulations and maintain the highest ethical standards, ensuring equal growth opportunities for everyone. The Group’s entities prohibit all forms of discrimination and promote a culture of diversity, openness, and mutual respect. The Group has established a comprehensive Anti-Bullying and Harassment Policy and is committed to preventing any form of workplace discrimination or misconduct.</p>
     Animal Rights and the Natural Environment
     <p>We operate in full compliance with environmental and animal welfare regulations. The Group’s entities aim to minimize their environmental footprint by reducing energy consumption, greenhouse gas emissions, and waste production. Our business decisions are made with the well-being of future generations in mind.</p>
     Information Protection
     <p>By implementing robust policies and procedures, we protect the personal data of all individuals and organizations we cooperate with, including employees, collaborators, clients, and partners. The Group ensures the security of confidential information, trade secrets, and proprietary know-how in accordance with national and international laws. In education, trust is essential; therefore, information security is our top priority.</p>
     Principles Applicable to Entities Maintaining Business Relations with the Group
     <p>The Group treats business partners with respect and professional integrity. We invite partners to cooperate based on shared ethical values and commitment to legal compliance. Business partners must not be subject to any financial or economic sanctions, nor can they cooperate with entities affected by such sanctions. The Group reserves the right to refuse or terminate cooperation in the event of any violation of the Group’s ethical principles.</p>
     Prevention of Crime, Corruption, Embezzlement, and Other Abuses
     <p>The Tutore Group stands firmly against all criminal acts, including corruption, bribery, embezzlement, money laundering, terrorist financing, and the forgery of currency or documents. Any employee or partner of the Group who observes irregularities is encouraged to use our anonymous whistleblower reporting procedure at: tutorepoland.liniaetyki.pl.</p>
     Final Provisions
     <p>This Code of Ethics applies to to all employees, collaborators, and individuals acting on behalf of the Group, as well our clients and business partners. The Group may issue additional internal documents to further detail these principles.</p>
     <p>All reports and inquiries related to the Code of Ethics should be sent to: compliance@tutore.eu.</p>

     <p style="margin-top: 30px;">I declare that I have read and accept the above Code of Ethics.</p>
    <div style="margin-top: 40px; font-size: 10px;">
      <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
      <p style="font-size: 14px;">Contractor's Signature</p>
    </div>
    </div>
  
    </td></tr>
    </tbody></table>
  
    </v-container>
  </template>
 
<script>
  export default {
    name: 'UmowaB2BNauczyciel2024TutoreMaleENG',
    data () {
      return {
        zamawiajacy: '',
        imieNazwisko: '',
        zamieszkany: '',
        korespondencyjny: '',
        pesel: '',
        nrRachunku: '',
        nrDowodu: '',
        nrTelefonu: '',
        email: '',
        emeryt: '',
        rencista: '',
        orzeczenieNiepelnosprawnosc: '',
        stopienNiepelnosprawnosc: '',
        student: '',
        jedenyTytulDoUbezpieczenia: '',
        chorobowe: '',
        zatrudnionyUmowaPraca: '',
        nazwaUmowaPraca: '',
        wynagrodzenieUmowaPraca: '',
        ubezpieczenieUmowaPraca: '',
        tytulUbezpieczenieUmowaPraca: '',
        umowaOd: '',
        umowaDo: '',
        urzadSkarbowy: '',
        nrUmowy: '',
        datapocz: '',
        datakon: '',
        kwota: '',
        wypo: '',
        slownie: '',
        kwotapokaz: '',
        slowniepokaz: '',
        shortUmowa: '',
        obywatelstwo: '',
        przedmiot: '',
        typZajec: '',
        stacjonarneJednostki: '',
        usluga: '',
        nazwaFirmy: '',
        siedzibaFirmy: '',
        nip: '',
        regon: '',
        wniosekUbezpieczenie: '',
        obywatelstwoOIZ: '',
        obywatelstwoDNI: '',
        tableRows: [
        { studentsNum: 'Demonstration classes', teacherWage: '', animatorWage: '31'},
        { studentsNum: '1-5', teacherWage: '', animatorWage: '31'},
        { studentsNum: '6', teacherWage: '+5', animatorWage: '35'},
        { studentsNum: '7', teacherWage: '+10', animatorWage: '40'},
        { studentsNum: '8', teacherWage: '+15', animatorWage: '45'},
        { studentsNum: '9', teacherWage: '+20', animatorWage: '50'},
        { studentsNum: '10', teacherWage: '+25', animatorWage: '55'},
        { studentsNum: '11', teacherWage: '+30', animatorWage: '60'},
        { studentsNum: '12', teacherWage: '+35', animatorWage: '65'},
        { studentsNum: '13', teacherWage: '+40', animatorWage: '70'},
        { studentsNum: '14', teacherWage: '+45', animatorWage: '75'},
        { studentsNum: '15 and more', teacherWage: '+50', animatorWage: '80'},
      ],
      };
    },
    created () {
      Object.entries(this.$route.query).forEach(
        ([key, value]) => { this[key] = value }
      )
    },
    methods: {
      shortNrUmowy () {
      let tab = []
      tab = this.nrumowy.split('/')
      this.shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/Naucz`
      return this.shortUmowa
    },
      dataObowiazywaniaUmowy () {
        if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
          return 'podpisania umowy przez obie strony'
        } else {
          return `${this.umowaOd} r.`
        }
      },
      aktualnaData() {
        const today = new Date();
        let day = today.getDate();
        if((day+1) <= 10) {
          day = '0' + day
        }
        let month = today.getMonth()+1;
        if ((today.getMonth()+1) < 10) {
          month = '0' + month
        } 
        const todayDate = day+'-'+month+'-'+today.getFullYear()
        return todayDate
      }
    },
    mounted () {
      if (this.zamawiajacy) {
        this.$nextTick(() => {
          window.setTimeout(() => {
            const currentURL = window.location.href
            history.replaceState(history.state, '', '/')
            window.print()
            history.replaceState(history.state, '', currentURL)
          }, 300)
        })
      }
    }
  }
  </script>
  
  <style scoped>

.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th, td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.right-cointainer {
  text-align: end;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}

.attachments {
  width: 100%;
}

.pelnomocnictwo {
  background-image: url('/src/assets/pelnomocnictwo_tutore_male.png');
}

.wage-table {
  border: 1px solid; 
  font-size: 12px; 
  margin: 20px;
  width: 50%;
}

.wage-table caption {
  text-align: left; 
}

.wage-table td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>




// WEBPACK FOOTER //
// src/components/UmowaB2BNauczyciel2024TutoreMaleENG.vue